import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { closeModal } from "@/store/modal.store";

interface OrientationsModalProps {
	orientations: string;
}

export function OrientationsModal({ orientations }: OrientationsModalProps) {
	return (
		<DialogContent className="max-w-2xl rounded-md p-8 max-h-[85vh] flex flex-col hc:bg-[#020617] hc:border-[#334155]">
			<DialogHeader className="flex flex-row items-center gap-4 space-y-0">
				<div className="size-12 rounded-md bg-primary/10 flex items-center justify-center text-primary shrink-0">
					<BookOpen size={24} />
				</div>
				<div>
					<DialogTitle className="text-xl font-bold text-[#0f172a] hc:text-[#f8fafc]">
						Orientações da prova
					</DialogTitle>
					<DialogDescription className="text-[#64748b] hc:text-[#94a3b8] text-sm mt-1">
						Leia atentamente antes de continuar
					</DialogDescription>
				</div>
			</DialogHeader>
			<div className="mt-4 overflow-y-auto flex-1 pr-2">
				<div
					className="text-[#475569] hc:text-[#cbd5e1] text-sm rich-html max-w-none"
					/* biome-ignore lint/security/noDangerouslySetInnerHtml: Intentional use for formatted orientations */
					dangerouslySetInnerHTML={{ __html: orientations }}
				/>
			</div>
			<div className="mt-6 pt-4 border-t border-[#f1f5f9] hc:border-[#334155]">
				<Button
					onClick={closeModal}
					className="w-full h-12 rounded-md font-bold"
				>
					Entendi
				</Button>
			</div>
		</DialogContent>
	);
}
